import { useQuery } from '@tanstack/react-query'
import {
	type GetVisualVettingListingsParams,
	httpGetVisualVettingListings
} from '@/features/luxe-submissions/http/luxe-submissions.http'

export const VISUAL_VETTING_LISTINGS_QUERY_KEY = 'visual-vetting-listings'

export const useGetVisualVettingListings = (
	params: GetVisualVettingListingsParams = {}
) =>
	useQuery({
		queryKey: [VISUAL_VETTING_LISTINGS_QUERY_KEY, params],
		queryFn: () => httpGetVisualVettingListings(params)
	})
